module.exports = __webpack_public_path__ + "static/_disease-db8132cbb222b3a2e9ea4b9f33f73d24.jpg";